import script from "./RightToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightToolbar.vue?vue&type=script&setup=true&lang=js"

import "./RightToolbar.vue?vue&type=style&index=0&id=67baa426&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67baa426"]])

export default __exports__